import RouterService from 'app_services/router/routerService';

export function useQuery(){
  const routerService = new RouterService()
  // return new URLSearchParams(useLocation().search)
  return {
    query: routerService.getParamsURL(),
    objectURL: routerService.getParamsURLObject()
  }
}
